import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToastrService } from 'ngx-toastr';

export class FileImportModalOptions {
  allowMultipleFiles: boolean;
  endpoint?: string;
  reqObj?: Object;
  heading?: string;
  submitButtonTitle?: string;
  acceptedFileTypes?: string[];
  templateImageName?: string;
}
@Component({
  selector: 'app-file-import-modal',
  templateUrl: './file-import-modal.component.html',
  styleUrls: ['./file-import-modal.component.scss'],
})
export class FileImportModalComponent {
  @ViewChild('fileDropRef') fileDropReference: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public options: FileImportModalOptions,
    private dialogRef: MatDialogRef<FileImportModalComponent>,
    private genericService: GenericService,
    private toastService: ToastrService,
  ) {}

  loading = false;
  showTemplate = false;
  dropError = '';

  files: File[] = [];

  close(result: any): void {
    this.dialogRef.close(result);
  }

  upload(): void {
    if (this.options.endpoint == null) {
      this.dialogRef.close(this.files);
      return;
    }
    this.loading = true;
    const formData = new FormData();
    this.files.forEach((file) => {
      formData.append('documents', file);
    });
    formData.append('body', JSON.stringify(this.options.reqObj));
    this.genericService.POST(this.options.endpoint, formData, true, null, '').subscribe(
      () => {
        this.loading = false;
        this.toastService.success('Changes may take up to 5 minutes to reflect in table.', 'Successfully Uploaded', { timeOut: 8000 });
        this.dialogRef.close(true);
      },
      () => {
        this.loading = false;
      },
    );
  }

  onFileDropped(files: FileList): void {
    const filesArr = Array.from(files);
    this.fileDropReference.nativeElement.value = '';
    if (!this.options.allowMultipleFiles && filesArr.length > 1) {
      this.showDropError('Only one file is allowed!');
      return;
    }
    if (!this.options.allowMultipleFiles && this.files.length > 0) {
      this.files = [];
    }
    this.files = this.files.concat(filesArr);
  }

  private showDropError(error: string): void {
    this.dropError = error;
    setTimeout(() => {
      this.dropError = '';
    }, 2000);
  }

  onFilePicked(e: any): void {
    this.onFileDropped(e.target.files);
  }

  deleteFile(index: number): void {
    this.files.splice(index, 1);
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  getAccpetedFileTypes(): string {
    return this.options.acceptedFileTypes?.toString() ?? '';
  }

  toggleTemplate(): void {
    this.showTemplate = !this.showTemplate;
  }
}

export function openFileImportDialog(dialog: MatDialog, options: FileImportModalOptions): Observable<any> {
  const config = new MatDialogConfig();
  config.data = options;
  config.minWidth = '200px';
  const dialogRef = dialog.open(FileImportModalComponent, config);
  return dialogRef.afterClosed();
}
